import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const EmailActivity = lazyLoad(
    () => import('./index'),
    module => module.EmailActivity,
    { fallback: <LoadingSpinner /> },
);
